import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { AppInjector } from '@zshared/utilities/injector';

bootstrapApplication(App, appConfig).then((moduleRef) => {
    // Get the root injector from the bootstrapped module
    const injector = moduleRef.injector;
    
    // Set the static injector reference in your custom class
    AppInjector.setInjector(injector);
})
  .catch((err) => console.error(err));


//   // import { registerLocaleData } from '@angular/common';
// // import vi from '@angular/common/locales/vi';
// // import { enableProdMode } from '@angular/core';
// import { bootstrapApplication } from '@angular/platform-browser';

// import { AppComponent } from './app/app.component';
// import { appConfig } from './app/app.config';
// // import { environment } from './environments/environment';

// // registerLocaleData(vi);

// // if (environment.production) {
// //     enableProdMode();
// // }

// bootstrapApplication(AppComponent, appConfig).catch((err) =>
//     console.error(err)
// );
